import BASE_URL from '@naruto/bgdapp/src/base/url';
import GUEST_PAGE_KEY from '@naruto/bgdapp/src/base/routes/GuestPageKey';
import { Routes } from '@naruto/bgdapp/src/base/routes/types';
import ProjectRoutes from '@naruto/bgdapp/src/base/routes/Project';

const GUEST_URL = BASE_URL.GUEST;

const Guest: Routes = {
  main: [
    {
      id: GUEST_PAGE_KEY.HOME,
      route: `${GUEST_URL.ROOT_PAGE_HOME}`,
      component: import('@naruto/bgdapp/src/components/Pages/Home'),
      exact: true,
      showInSidebar: true,
      root: true,
      subRoute: [],
      lang: 'frontend.global.route.home',
      icon: '',
      iconActive: ''
    },
    {
      id: GUEST_PAGE_KEY.SERVE,
      route: `${GUEST_URL.ROOT_PAGE_SERVICE}`,
      component: import('@naruto/bgdapp/src/components/Pages/Service'),
      exact: true,
      showInSidebar: true,
      subRoute: [],
      lang: 'frontend.global.route.service',
      icon: '',
      iconActive: ''
    },
    {
      id: GUEST_PAGE_KEY.PROJECT,
      route: `${GUEST_URL.ROOT_PAGE_PROJECT}`,
      component: import('@naruto/bgdapp/src/components/Pages/Project'),
      exact: false,
      showInSidebar: true,
      subRoute: [...ProjectRoutes.main],
      lang: 'frontend.global.route.project',
      icon: '',
      iconActive: ''
    },
    {
      id: GUEST_PAGE_KEY.CONTACT,
      route: `${GUEST_URL.ROOT_PAGE_CONTACT}`,
      component: import('@naruto/bgdapp/src/components/Pages/Contact'),
      exact: true,
      showInSidebar: true,
      subRoute: [],
      lang: 'frontend.global.route.contact',
      icon: '',
      iconActive: ''
    },
    {
      id: GUEST_PAGE_KEY.SIGN_IN,
      route: `${GUEST_URL.ROOT_PAGE_SIGN_IN}`,
      component: import('@naruto/bgdapp/src/components/Pages/SignIn'),
      exact: true,
      showInSidebar: false,
      subRoute: [],
      icon: '',
      iconActive: ''
    }
  ]
};

export default Guest;
